import { ChatThreadModel, ThreadApi } from "../../../@api";

import { IChatThreadExtendedModel } from "../../models/interfaces";
import { IStoreContext } from "../../stores/StoreContext";
import { ThreadApiService } from "../ApiServices/ThreadApiService";
import { GenericService } from "../GenericService";

export class ThreadService extends GenericService<ThreadApi, ThreadApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, ThreadApi, ThreadApiService);
  }

  public async loadThreads(abortController?: AbortController): Promise<void> {
    this.storeContext.threadStore.loadingThreads = true;
    const threads = this.storeContext.threadStore.threads;

    const updatedThreads = await this.apiService.getAllUserThreads({
      signal: abortController?.signal,
    });

    this.storeContext.threadStore.threads = updatedThreads.map((updatedThread: ChatThreadModel) => {
      // NOTE #63781 find a thread with the previous state to set the existing values for pendingPrompt and isExchangeCancelled
      const existingThread = threads.find((thread: IChatThreadExtendedModel) => thread.id === updatedThread.id);

      const extendedThread = {
        ...updatedThread,
        pendingPrompt: undefined,
        isExchangeCancelled: existingThread?.isExchangeCancelled || false,
        modelId: existingThread?.modelId,
      };

      return extendedThread;
    });

    this.storeContext.threadStore.loadingThreads = false;
  }

  public async deleteThread(threadId: string): Promise<void> {
    return this.apiService.deleteThread({ threadId });
  }
}
